<filter-panel
    [isOpened]="isOpened"
    (isOpenedChange)="filterPanelOpenedChanged($event)"
    (onSearch)="onSearch.emit()"
    (onClear)="onClear.emit()"
    (pinnedChange)="pinnedChange.emit()"
>
    <dx-form [formData]="filterModel">
        <dxi-item
            [dataField]="'employee.name'"
            editorType="dxTextBox"
            [editorOptions]="{ placeholder: 'Employee', stylingMode: 'filled' }"
            [colSpan]="1"
        ></dxi-item>
        <dxi-item
            [dataField]="filterModelName('submittedDate')"
            editorType="dxDateBox"
            [editorOptions]="{ placeholder: 'Submitted Date', stylingMode: 'filled' }"
            [colSpan]="1"
        ></dxi-item>
        <dxi-item
            [dataField]="filterModelName('status')"
            editorType="dxSelectBox"
            [editorOptions]="{
                placeholder: 'Status',
                stylingMode: 'filled',
                items: statusOptions,
                valueExpr: 'value',
                displayExpr: 'text'
            }"
            [colSpan]="1"
        ></dxi-item>
        <dxi-item
            [dataField]="filterModelName('number')"
            editorType="dxTextBox"
            [editorOptions]="{placeholder: 'Number',stylingMode: 'filled'}"
            [colSpan]="1"
        ></dxi-item>
    </dx-form>
</filter-panel>
